import React from 'react';
import Form from 'react-bootstrap/Form'; //for toggle
import { useSelector, useDispatch } from 'react-redux';
import { appLanguages } from '../../constants/appConstants';
import { changeLanguage, generalReducer } from '../../redux/generalSlice';
import { getUserNavItems } from './layoutUtils';
import { authInfo } from '../../pages/auth/authSlice';
import MenuComponent from './MenuComponent';
import NavProfile from './NavProfile';

const Leftbar = ({ showMenu }) => {
  const { appLanguage } = useSelector(generalReducer);
  const {
    isLoggedIn,
    user: { activeJurisdiction },
  } = useSelector(authInfo);

  const dispatch = useDispatch();

  const handleSwitchChange = () => {
    if (appLanguage === appLanguages.Bengali) {
      dispatch(changeLanguage(appLanguages.English));
      return;
    }
    dispatch(changeLanguage(appLanguages.Bengali));
  };

  return (
    <>
      <div className={showMenu ? 'leftbar-wrapper leftbar-show' : 'leftbar-wrapper  leftbar-hide'}>
        <div className='width-leftbar d-flex flex-column'>
          <div className='d-flex flex-column px-2 px-lg-3 gap-3'>
            {isLoggedIn && (
              <MenuComponent menuItems={getUserNavItems(activeJurisdiction.permissions)} />
            )}
            <div className='d-md-none'>
              <NavProfile
                className={'leftbar-nav-profile'}
                toggleClass={'leftbar-nav-profile-dropdown'}
                nameDesignationClass={'leftbar-nav-name-designation'}
                profileNameClass={'leftbar-profile-name-text'}
                designationNameClass={'leftbar-profile-designation-text'}
                workStationNameClass={'leftbar-profile-workstation-text'}
                dropdownItemClassName={'leftbar-dropdown-item'}
              />
            </div>
          </div>
        </div>
      </div>

      <div
        className={
          showMenu
            ? 'language-toggle-container language-toggle-container-show '
            : 'language-toggle-container language-toggle-container-hide'
        }
      >
        <div className='d-flex flex-column '>
          <Form className='d-flex  justify-content-center  align-items-center fs-6  border-top px-4 px-lg-5'>
            <label
              className='language-toggle-text mt-2 text-decoration-none'
              htmlFor='languageChangeSwitch'
            >
              English
            </label>
            <Form.Check
              type='switch'
              checked={appLanguage === appLanguages.Bengali}
              className='mt-2 ms-2'
              onChange={handleSwitchChange}
              id='languageChangeSwitch'
            />
            <label
              className='language-toggle-text mt-2 text-decoration-none'
              htmlFor='languageChangeSwitch'
            >
              বাংলা
            </label>
          </Form>
          <span className='p-1 text-center fw-light'>
            <span className='text-small'>
              All rights reserved by directorate of secondary and higher education
            </span>
          </span>
        </div>
      </div>
    </>
  );
};

export default Leftbar;
